var _ellipse, _ellipse2, _circle, _circle2, _path, _path2, _circle3, _circle4, _circle5, _circle6, _ellipse3, _path3, _line, _line2, _line3, _line4, _circle7, _circle8, _circle9, _circle10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDogSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dogFooterGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#00D4FF",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1DD3B0",
      stopOpacity: 0.4
    }
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24,
    cy: 28,
    rx: 12,
    ry: 10,
    fill: "url(#dogFooterGradient)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24,
    cy: 28,
    rx: 12,
    ry: 10,
    stroke: "#00D4FF",
    strokeWidth: 1.5,
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 16,
    r: 7,
    fill: "url(#dogFooterGradient)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 16,
    r: 7,
    stroke: "#00D4FF",
    strokeWidth: 1.5,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 18 13 L 15 7 L 20 11",
    fill: "url(#dogFooterGradient)",
    stroke: "#00D4FF",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 30 13 L 33 7 L 28 11",
    fill: "url(#dogFooterGradient)",
    stroke: "#00D4FF",
    strokeWidth: 1.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 16,
    r: 1.5,
    fill: "#00D4FF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 16,
    r: 1.5,
    fill: "#00D4FF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.3,
    cy: 15.7,
    r: 0.6,
    fill: "#E8EAED"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.3,
    cy: 15.7,
    r: 0.6,
    fill: "#E8EAED"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24,
    cy: 19,
    rx: 1.5,
    ry: 1,
    fill: "#1DD3B0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 35 26 Q 40 22 42 18",
    stroke: "#00D4FF",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 36,
    x2: 17,
    y2: 42,
    stroke: "#00D4FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 36,
    x2: 23,
    y2: 42,
    stroke: "#00D4FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 36,
    x2: 25,
    y2: 42,
    stroke: "#00D4FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 31,
    y1: 36,
    x2: 31,
    y2: 42,
    stroke: "#00D4FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 42,
    r: 1.5,
    fill: "#00D4FF"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 42,
    r: 1.5,
    fill: "#00D4FF"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 42,
    r: 1.5,
    fill: "#00D4FF"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 42,
    r: 1.5,
    fill: "#00D4FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDogSmall);
export default __webpack_public_path__ + "static/media/dog-small.11457fc2c14077741ecdbf4460f0b4a1.svg";
export { ForwardRef as ReactComponent };